/*
  Add class to body
*/
const bodyClass = () => {
  // JS is obviously enabled
  document.body.classList.add("js--on");

  // Test if it's a touch device
  const touch = "ontouchstart" in document.documentElement ? "on" : "off";
  document.body.classList.add(`touch--${touch}`);
};

export default bodyClass;
